export default class Response<T = any> {
  public error: boolean
  public data: T | null
  public aborted: boolean

  constructor(data: Partial<Response<T>> = {}) {
    this.data = data.data ?? null
    this.error = data.error ?? false
    this.aborted = data.aborted ?? false
  }
}
